export const tags = [
    { id: 'pages', label: 'Top Pages' },
    { id: 'authors', label: 'Top Authors' },
];
